import classNames from 'classnames';
import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {toggleAnimation} from '../../../general/actionCreators';

const PlayLabel = gettext('Play');
const StopLabel = gettext('Stop');

const PlayButton = ({label, className, onClick}) => (
    <button className={classNames('met-btn', className)} title={label} onClick={onClick}>
        <span className="desktop-only">{label}</span>
    </button>
);

const mapStateToProps = ({isAnimating}) => ({
    label: isAnimating ? StopLabel : PlayLabel,
    className: isAnimating ? 'is-stop' : 'is-play',
});

const mapDispatchToProps = dispatch => ({
    onClick: () => dispatch(toggleAnimation),
});

export default connect(mapStateToProps, mapDispatchToProps)(PlayButton);
